/* eslint-disable @typescript-eslint/naming-convention */
import 'reflect-metadata';
import {FormElement, FormElementConfiguration} from 'app/entities/form/formElement.entity';
import {Type} from 'class-transformer';
import {FormElementCheckbox, FormElementCheckboxConfiguration} from 'app/entities/form/formElementCheckbox.entity';
import {Entity} from 'app/core/main.entity';
import {FormElementText} from 'app/entities/form/formElementText.entity';
import {FormElementTextarea} from 'app/entities/form/formElementTextarea.entity';
import {FormElementSelect} from 'app/entities/form/formElementSelect.entity';
import {FormElementData, FormElementDataRange} from 'app/entities/form/formElementDate.entity';
import {FormElementFile} from 'app/entities/form/formElementFile.entity';
import {FormElementNumber} from 'app/entities/form/formElementNumber.entity';
import {FormElementSegment} from 'app/entities/form/formElementSegment.entity';
import {FormElementToggle} from 'app/entities/form/formElementToggle.entity';
import {FormElementRadio} from 'app/entities/form/formElementRadio.entity';
import {FormElements} from 'app/entities/form/form.entity';
import {FormElementRepeater} from 'app/entities/form/formElementRepeater.entity';
import {FormElementCustomCalendarRepeat} from 'app/entities/form/formElementCustomCalendarRepeat.entity';
import {FormElementType} from 'app/entities/enums';

export class FormElementGroup extends FormElement {
  type: FormElementType = 'group';

  @Type(() => FormElementGroupConfiguration)
  configuration?: FormElementGroupConfiguration = new FormElementGroupConfiguration();
}

export class FormElementGroupConfiguration extends FormElementConfiguration {

  @Type(() => Entity, {
    discriminator: {
      property: 'type',
      subTypes: [
        {value: FormElementText, name: 'text'},
        {value: FormElementTextarea, name: 'textarea'},
        {value: FormElementSelect, name: 'select'},
        {value: FormElementCheckbox, name: 'checkbox'},
        {value: FormElementData, name: 'date'},
        {value: FormElementDataRange, name: 'dateRange'},
        {value: FormElementFile, name: 'file'},
        {value: FormElementNumber, name: 'number'},
        {value: FormElementSegment, name: 'segments'},
        {value: FormElementToggle, name: 'toggle'},
        {value: FormElementRadio, name: 'radio'},
        {value: FormElementCustomCalendarRepeat, name: 'calendarRepeat'}
      ],
    },
    keepDiscriminatorProperty: true
  })
  fields: FormElements[] = [];
}

